import React from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { formatDate } from '../../js/utils'
import '../../css/client-table.css'

const ClientTableFooter = ({ addClient }) => {
  return (
    <div className="p-helper-clearfix" style={{ width: '100%' }}>
      <Button icon="pi pi-plus" label="Add Client" onClick={addClient} />
    </div>
  )
}

const StartDateTemplate = rowData => {
  return <span>{formatDate(rowData['StartDate'])}</span>
}

const EndDateTemplate = rowData => {
  return <span>{formatDate(rowData['EndDate'])}</span>
}

const ClientTable = ({ canSave, addClient, selectedClient, selectClient, clients, isAnnualReturn }) => {
  let columnDefinitions = [
    { field: 'Name', header: 'Client Name' }
  ]
  if (isAnnualReturn) {
    let annualReturnColumns = [
      { field: 'SubjectDiscussed', header: 'Subject Discussed' },
      { field: 'PublicOfficialMet', header: 'Name of Public Official(s)', className: 'display-linebreak' }
    ]
    columnDefinitions = columnDefinitions.concat(annualReturnColumns)
  }
   if (!isAnnualReturn) {
    let dateColumns = [
      { field: 'StartDate', header: 'Start Date', body: StartDateTemplate },
      { field: 'EndDate', header: 'End Date', body: EndDateTemplate }
    ];
    columnDefinitions = columnDefinitions.concat(dateColumns);
  }

  let columns = columnDefinitions.map((col, i) => {
    return <Column key={col.field} field={col.field} header={col.header} body={col.body} className={col.className} />
  })

  let footer = canSave === true && isAnnualReturn === false ? <ClientTableFooter addClient={addClient} isAnnualReturn={isAnnualReturn} /> : ''

  // sort by end date descending with null dates on top
  clients.sort((a, b) => {
    if (b.EndDate === null && a.EndDate === null) {
      return a.Name.localeCompare(b.Name)
    } else if (b.EndDate === null) {
      return 1
    }
    else if (a.EndDate === null) {
      return -1
    } else {
      return (new Date(b.EndDate) - new Date(a.EndDate)) && a.Name.localeCompare(b.Name)
    }
  })

  return (
    <DataTable value={clients} footer={footer} selectionMode="single" selection={selectedClient} responsive={true}
      onSelectionChange={selectClient} className="client-table">
      {columns}
    </DataTable>
  )
}

export default ClientTable



// WEBPACK FOOTER //
// ./src/components/client/client-table.js